/* RESPONSIBLE TEAM: team-inbox */
import {
  VALID_ACTION_TYPES,
  AWAY_MODE_KEY,
  REPORTS_DELETE_KEY,
} from 'embercom/lib/settings/permissions/constants';

export default function isActionPermission(permissionKey) {
  if (permissionKey === AWAY_MODE_KEY || permissionKey === REPORTS_DELETE_KEY) {
    return false;
  }

  // Exclude macro permissions - they're hierarchical but not action-based
  if (
    permissionKey === 'can_create_macros' ||
    permissionKey === 'can_edit_macros' ||
    permissionKey === 'can_delete_macros'
  ) {
    return false;
  }

  return VALID_ACTION_TYPES.some((action) => permissionKey.includes(action));
}
